// Auto-import all SVG icons from the icons directory
// This file is generated automatically to import all SVG icons

// Import all SVG files from the icons directory
const iconContext = require.context('../img/icons', false, /\.svg$/);

// Export all icons so they are processed by webpack
iconContext.keys().forEach(iconContext);



// WEBPACK FOOTER //
// ./src/js/icons.js